var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGasPump = function SvgGasPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m39.04 14.46.02-.02L31.62 7 29.5 9.12l4.22 4.22c-1.88.72-3.22 2.52-3.22 4.66 0 2.76 2.24 5 5 5 .72 0 1.38-.16 2-.42V37c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-2.2-1.8-4-4-4h-2V10c0-2.2-1.8-4-4-4h-12c-2.2 0-4 1.8-4 4v32h20V27h3v10c0 2.76 2.24 5 5 5s5-2.24 5-5V18c0-1.38-.56-2.64-1.46-3.54M23.5 27v11h-12V24h12zm0-7h-12V10h12zm12 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
  }))));
};
export default SvgGasPump;